import AmountGeneralRequest from '../../components/utilities/Table/generalColumns/AmountGeneralRequest';
import { RequestIdWithWarning } from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
const commonColumns = [
    RequestIdWithWarning(),
    {
        id: 'fecha_creacion',
        Header: 'Fecha Creación ',
        accessor: 'gestionsolicitud.fecha_creacion',
    },
    {
        id: 'producto_solicitud',
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        id: 'identificacion_cliente',
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
        typeId: 'HeaderClient',
    },
    {
        id: 'cliente_nombre',
        Header: 'Cliente',
        accessor: 'persona.full_name',
    },
    AmountGeneralRequest({
        id: 'monto_soli',
        Header: 'Monto solicitud',
        accessor: 'monto_solicitado',
    }),
    {
        Header: 'Estado',
        accessor: 'estado_solicitud.label',
    },
];

const requestsListStatus = [
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '47',
        responsable: true,
        columns: commonColumns,
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        responsable: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 47,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_creacion',
                value: 'user',
                operator: '|',
            },
            // {
            //     name: 'gestionsolicitud__usuario_rechazo',
            //     value: 'user',
            //     operator: '|',
            // },
            // {
            //     name: 'gestionsolicitud__usuario_desistimiento',
            //     value: 'user',
            //     operator: '|',
            // },
        ],
        columns: commonColumns,
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
